<!--
 * @Author: maogangfeng
 * @Date: 2020-03-12 18:20:35
 * @Desc: 自定义的简单的Tab
 -->
<template>
  <div :class="[isActive ? 'tab-pane-selected' : '', 'tab-pane']" @click="handleTabClick">
    {{ label }}
  </div>
</template>
<script>
export default {
  name: 'TabPane',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    activeTab: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 判断当前是否被选择
    isActive() {
      return this.name === this.activeTab
    }
  },
  methods: {
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-12 18:59:37
     * @Desc: tab的点击事件
     */
    handleTabClick() {
      this.$emit('select', this.name)
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-pane {
  width: 144px;
  height: 40px;
  position: relative;
  margin-right: 10px;
  font-family: MicrosoftYaHei;
  font-size: 24px;
  color: #5f98a2;
  letter-spacing: 0;
  text-align: center;
  cursor: pointer;
  &::before {
    content: '';
    width: 100%;
    height: 4px;
    background: #28494f;
    position: absolute;
    top: 100%;
    left: 0;
    transform: skewX(45deg);
  }
  &::after {
    content: '';
    width: 0;
    height: 4px;
    background: #bffff5;
    box-shadow: 0 8px 12px 0 #699a92;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: skewX(45deg);
    transition: all 0.8s;
  }
  &:hover {
    color: #eefffc;
    text-shadow: 0 0 11px #bffff5;
  }
}
.tab-pane-selected {
  color: #eefffc;
  text-shadow: 0 0 11px #bffff5;
  &::after {
    left: 0%;
    width: 100%;
  }
}
</style>
